import React from "react";
import Footer from "./layout/Footer";
import LetsChat from "./layout/LetsChat";
import { SiteProvider } from "../utils/context";
import { SearchEngineOptimisation } from "./SearchEngineOptimisation";
import { motion, useScroll } from "motion/react";

import CookieConsent from "react-cookie-consent";
import { Link } from "gatsby";

import { useState } from "react";
import { BsSearch } from "react-icons/bs";
import normalizeWheel from "normalize-wheel";
import MobileNav from "./layout/MobileNav";
import WebinarSignUp from "./layout/WebinarSignUp";

export default function Layout({ children }) {
  const { scrollYProgress } = useScroll();
  const [isHeaderHidden, setIsHeaderHidden] = useState(false);
  const [prevTouchY, setPrevTouchY] = useState(null);

  const handleScroll = (e) => {
    e.preventDefault();
    // desktop scroll
    if (e.type === "wheel" || e.type === "scroll") {
      const normalized = normalizeWheel(e);
      let scrollTop = normalized.pixelY;
      console.log(scrollTop);
      if (scrollTop > 0) {
        setIsHeaderHidden(true);
      } else if (scrollTop < 0) {
        setIsHeaderHidden(false);
      }
    }
    // mobile scroll
    else if (e.type === "touchmove") {
      const touch = e.changedTouches[0];
      const currentTouchY = touch.clientY;

      if (prevTouchY !== null) {
        if (currentTouchY > prevTouchY) {
          setIsHeaderHidden(false);
        } else if (currentTouchY < prevTouchY) {
          setIsHeaderHidden(true);
        }
      }
      setPrevTouchY(currentTouchY);
    }
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    const touch = e.changedTouches[0];
    const currentTouchY = touch.clientY;
    setPrevTouchY(currentTouchY);
  };

  const handleTouchEnd = (e) => {
    const touch = e.changedTouches[0];
    const currentTouchY = touch.clientY;
    setPrevTouchY(currentTouchY);
  };

  return (
    <div
      className="relative"
      // desktop
      onWheel={(e) => handleScroll(e)}
      onScroll={(e) => handleScroll(e)}
      // mobile
      onTouchMove={(e) => handleScroll(e)}
      onTouchStart={(e) => handleTouchStart(e)}
      onTouchEnd={(e) => handleTouchEnd(e)}
    >
      <SiteProvider>
        <SearchEngineOptimisation />
        <LetsChat />
        <WebinarSignUp />

        <div>
          <MobileNav />
          <div className="hidden lg:block">
            <header
              className={`headerNav ${
                isHeaderHidden === true ? "hiddenNav " : ""
              }`}
            >
              <nav className="container mx-auto ">
                <ul className="flex justify-end container max-w-full xl:max-w-[74rem] mx-auto">
                  <li className="px-1 py-2 mr-auto">
                    <Link
                      to={"/"}
                      className="ml-2 mr-auto relative inline-flex items-center justify-center px-5 py-3 overflow-hidden bg-novaPink text-white  rounded-full group  "
                    >
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink2 rounded-full group-hover:w-56 group-hover:h-56 "></span>

                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                      <span className="relative text-base font-semibold">
                        <img
                          src="https://novacom.group/gatsby/wp-content/uploads/2025/02/novacom-logo.svg"
                          alt="Novacom"
                          layout="fixed"
                          width={116}
                          height={16}
                          className=""
                        />
                      </span>
                    </Link>
                  </li>
                  <li className="px-1 py-2">
                    <Link
                      to={"/services"}
                      className="relative inline-flex items-center justify-center px-4 py-2 overflow-hidden text-white  rounded-full group  "
                    >
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink rounded-full group-hover:w-56 group-hover:h-56 "></span>

                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                      <span className="relative text-base font-semibold">
                        Services
                      </span>
                    </Link>
                  </li>
                  <li className="px-1 py-2">
                    <Link
                      to={"/work"}
                      className="relative inline-flex items-center justify-center px-4 py-2 overflow-hidden text-white  rounded-full group"
                    >
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink rounded-full group-hover:w-56 group-hover:h-56"></span>

                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                      <span className="relative text-base font-semibold">
                        Work
                      </span>
                    </Link>
                  </li>
                  <li className="px-1 py-2">
                    <Link to={"/resources"}>
                      <button className="relative inline-flex items-center justify-center px-4 py-2 overflow-hidden text-white  rounded-full group">
                        <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink rounded-full group-hover:w-56 group-hover:h-56"></span>

                        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                        <span className="relative text-base font-semibold">
                          Resources
                        </span>
                      </button>
                    </Link>
                  </li>

                  <li className="px-1 py-2">
                    <Link
                      to={"/about-us"}
                      className="relative inline-flex items-center justify-center px-4 py-2 overflow-hidden text-white  rounded-full group"
                    >
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink rounded-full group-hover:w-56 group-hover:h-56"></span>

                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                      <span className="relative text-base font-semibold">
                        About us
                      </span>
                    </Link>
                  </li>

                  <li className="px-1 py-2">
                    <Link
                      to={"/insights"}
                      className="relative inline-flex items-center justify-center px-4 py-2 overflow-hidden text-white  rounded-full group"
                    >
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink rounded-full group-hover:w-56 group-hover:h-56"></span>

                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                      <span className="relative text-base font-semibold">
                        Insights
                      </span>
                    </Link>
                  </li>

                  <li className="px-1 py-2">
                    <Link
                      to={"/contact-us"}
                      className="relative inline-flex items-center justify-center px-4 py-2 overflow-hidden text-white  rounded-full group"
                    >
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink rounded-full group-hover:w-56 group-hover:h-56"></span>

                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                      <span className="relative text-base font-semibold">
                        Contact us
                      </span>
                    </Link>
                  </li>
                  <li className="px-1 py-2 pr-6">
                    <Link
                      to={"/search"}
                      className="relative inline-flex items-center justify-center px-4 py-2 overflow-hidden text-white  rounded-full group"
                    >
                      <span className="absolute w-0 h-0 transition-all duration-500 ease-in-out bg-novaPink rounded-full group-hover:w-56 group-hover:h-56"></span>

                      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg"></span>
                      <span className="relative text-base font-semibold">
                        Search{" "}
                        <BsSearch className="inline-block ml-2 text-md text-novaBlue -mt-1" />
                      </span>
                    </Link>
                  </li>
                </ul>
              </nav>
            </header>
          </div>

          <div
            className={`headerProgress ${
              isHeaderHidden === false ? "" : "hiddenProgress"
            }`}
          >
            <svg
              aria-hidden="true"
              id="progress"
              width="44"
              height="44"
              viewBox="0 0 100 100"
              className="w-[48px] h-[48px] lg:h-[44px] lg:-w[44px] rounded-full z-40"
            >
              <circle
                cx="50"
                cy="50"
                r="30"
                pathLength="1"
                className="stroke-novaGrey"
              />
              <motion.circle
                cx="50"
                cy="50"
                r="30"
                className="indicator"
                style={{ pathLength: scrollYProgress }}
              />
            </svg>
          </div>
          <main tabIndex="-1">{children}</main>
        </div>

        <Footer />
        <CookieConsent
          enableDeclineButton
          location="bottom"
          buttonText="Accept"
          declineButtonText="Decline"
          className="font-light text-center cookies CookieConsent"
          cookieName="gatsby-gdpr-google-analytics"
          style={{ justifyContent: "center", display: "flex" }}
          role="cookie banner"
        >
          <div
            style={{ flex: "0 0 auto", display: "block" }}
            role="cookie banner"
          >
            This website uses cookies to give you the best experience. We take
            privacy and the security of your data very seriously, and you can
            find out more about this in our{" "}
            <Link
              className="text-white border-b border-transparent hover:border-white hover:text-white"
              to="/legal-and-privacy"
              target="blank"
            >
              privacy policy
            </Link>
            .
          </div>
        </CookieConsent>
      </SiteProvider>
    </div>
  );
}
